<template>
  <div class="thesis-practice-popper-sample-template">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog width="500px"
                    custom-class="thesis-practice-popper-sample-template-dialog"
                    title="开题报告模板样例"
                    :visible.sync="visible"
                    @open="initData">
      <div class="sample-template-main">
        <div class="upload-template-wrap">
          <div class="upload-template">
            <FileLinkUploader v-model="syllabusTemplate"
                              result-key="syllabusTemplate"
                              :show-file-list="false"
                              :upload-url="uploader.uploadUrl"
                              :upload-params="uploadParams"
                              :support-types="uploader.supportTypes"
                              :max-size="uploader.maxSize"
                              @handle-success="handleSuccess">
              <template #trigger="{disabled}">
                <el-button type="primary"
                           icon="el-icon-upload2"
                           :disabled="disabled">上传模板样例</el-button>
              </template>
            </FileLinkUploader>
          </div>
          <span class="tip">支持上传jpg/jpeg/png/doc/docx/pdf格式</span>
        </div>
        <div class="file-list" v-if="previewUrl">
          <div class="file-name">模板样例：</div>
          <div class="preview">
            <FilePreview :previewUrl="previewUrl"></FilePreview>
          </div>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import FilePreview from '../../../../../../../../widgets/custom/FilePreview'
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
import FileLinkUploader from '../../../../../../../../widgets/custom/wrapper/FileLinkUploader'
export default {
  name: 'ThesisPracticePopperSampleTemplate',
  components: {
    FilePreview,
    DataGridDialog,
    FileLinkUploader
  },
  props: {
    syllabusTemplateFile: {
      type: String
    },
    syllabusTemplatePreview: {
      type: String
    },
    paperBatchId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      uploader: {
        uploadUrl: '/workspace/manager/paper/batch/uploadSyllabusTemplate',
        supportTypes: ['.jpg', '.jpeg', '.png', '.doc', '.docx', '.pdf'],
        maxSize: 100 * 1024 * 1024
      },
      syllabusTemplate: '',
      previewUrl: ''
    }
  },
  computed: {
    uploadParams () {
      return {
        paperBatchId: this.paperBatchId
      }
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleSuccess ({syllabusTemplate}) {
      if (syllabusTemplate) {
        this.previewUrl = syllabusTemplate.previewUrl
        this.syllabusTemplate = syllabusTemplate.sourceUrl
      }
    },
    initData () {
      this.syllabusTemplate = this.syllabusTemplateFile
      this.previewUrl = this.syllabusTemplatePreview
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (!val) {
          this.syllabusTemplate = ''
          this.FilePreview = ''
        }
      }
    },
    syllabusTemplate (newVal) {
      if (newVal) {
        this.$emit('update:syllabusTemplateFile', newVal)
      }
    }
  }
}
</script>

<style lang="scss">
.thesis-practice-popper-sample-template{
  display: inline-block;
}
.thesis-practice-popper-sample-template-dialog{
  .sample-template-main{
    padding: 20px;
    & > .upload-template-wrap{
      padding-bottom: 15px;
      & > .upload-template{
        width: 150px;
        margin-bottom: 10px;
        .file-uploader-wrap{
          .el-upload{
            .el-button {
              i {
                margin-left: -10px;
              }
            }
          }
        }
      }
      & > .tip{
        font-size: 12px;
      }
    }
    & > .file-list{
      display: flex;
      align-items: center;
      padding-top: 15px;
      font-size: 12px;
      border-top: 1px solid #dde5eb;
    }
  }
}
</style>
